import WarrantyModal from './WarrantyModal.vue'

export default WarrantyModal
